export const openUrl = (url: string, isNewTab?: boolean) => {
  if (isNewTab) {
    window.open(url);
  } else {
    // eslint-disable-next-line xss/no-location-href-assign
    window.location.href = url;
  }
};
